import React from "react";
import { formatDisplayNumber } from "../../../../../../../../../utility/utils";

// Inventario disponible en el almacén de reproceso. Las pacas de los pallets se
// convierten a kg para poder sumarlas con el sobrante; como el DRC del
// reproceso es 100%, esos kg son a la vez los kg secos.
export const DisponibleReproceso = ({ reprocesoHook }) => {
    const { pacas, kgSobrante, kgTotal } = reprocesoHook.disponibleAlmacen;

    return (
        <div className="formulario-field">
            <label className="text-nowrap">Disponible en el almacén</label>
            <input
                type="text"
                className="form-control"
                disabled
                value={`${formatDisplayNumber(kgTotal, 2)} kg`}
            />
            <small className="d-block text-muted">
                {formatDisplayNumber(pacas)} pacas +{" "}
                {formatDisplayNumber(kgSobrante, 2)} kg de sobrante
            </small>
        </div>
    );
};
